import { Box, Typography } from '@mui/material';
import { JSX } from 'react';
import clsx from 'clsx';
import PolicyCardSection, { PolicyCardSectionProps } from './policyCardSection';

interface PolicyCardProps {
  /**
   * Card title
   */
  title?: string;
  /**
   * Card sections
   */
  sections: PolicyCardSectionProps[];
  /**
   * Optional class name for the sections container
   */
  sectionsClassName?: string;
  /**
   * Optional class name for the card
   */
  className?: string;
}

/**
 * Policy card component.
 * Used to display FNA needs cards, policies and etc.
 */
const PolicyCard = ({
  className,
  sectionsClassName,
  sections,
  title,
}: PolicyCardProps): JSX.Element => (
  <Box className={clsx(className, 'leading-none')}>
    {title && <Typography variant="h4">{title}</Typography>}
    <Box className={sectionsClassName}>
      {sections.map((section, index) => (
        <PolicyCardSection key={section.title || index} {...section} />
      ))}
    </Box>
  </Box>
);

export default PolicyCard;
